import { Component, type ErrorInfo, type ReactNode } from 'react'
import BootError from './BootError'

type RootErrorBoundaryProps = {
  children: ReactNode
}

type RootErrorBoundaryState = {
  error: Error | null
}

export default class RootErrorBoundary extends Component<RootErrorBoundaryProps, RootErrorBoundaryState> {
  state: RootErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): RootErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('KILO root render error:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <BootError
          title="Something crashed while loading KILO"
          message="The app hit a runtime error before it could finish rendering."
          details={this.state.error.message}
        />
      )
    }

    return this.props.children
  }
}
